export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["显示："])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["总计"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["每页"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["显示"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["结果"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["中的"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["交易"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["交易"])}
}